<template>
  <main class="mt-5 admin-order">
    <div class="card mt-3">
      <div class="card-body" v-if="order">
        <OrderInfo
          @update-order-status="updateOrderStatus"
          :order="order"
        />
        <OrderAddress :order="order" />
        <OrderInvoices :order="order" />
        <OrderItems :order="order" :disabled="disabled" />
      </div>
      <Loading v-else />
    </div>
    <OrderChangeStatus
      :order="order"
      :disabled="disabled"
      ref="changeOrderStatus"
    />
  </main>
</template>
<script>
import OrderDetailImpl from "@@/core/pages/order/OrderDetail/OrderDetailImpl";
export default {
  components: {},
  extends: OrderDetailImpl,
};
</script>
<style
  scoped
  src="@@/core/pages/order/OrderDetail/OrderDetailStyle.css"
></style>
<style src="@@/core/pages/order/OrderDetail/OrderDetailStylePublic.css"></style>
